 export enum ResponseTimeGranularity {
        ThirtySeconds  = "ThirtySeconds",
        OneMinute = "OneMinute",
        FiveMinutes = "FiveMinutes",
        FifteenMinutes = "FifteenMinutes",
        OneHour = "OneHour",
        SixHours = "SixHours",
        OneDay = "OneDay",
        SevenDays = "SevenDays",
        ThirtyDays = "ThirtyDays"
 }